import { render, staticRenderFns } from "./KT-ReminderOpt.vue?vue&type=template&id=6908ce66&scoped=true&lang=pug&"
import script from "./KT-ReminderOpt.vue?vue&type=script&lang=js&"
export * from "./KT-ReminderOpt.vue?vue&type=script&lang=js&"
import style0 from "./KT-ReminderOpt.vue?vue&type=style&index=0&id=6908ce66&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6908ce66",
  null
  
)

export default component.exports